import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Bubble} from 'kpc';

var _$tmp0 = {
    'shape': 'round',
    'variant': 'outlined',
    'content': 'round 更柔和，适合需要更强亲和感的对话场景。'
};
var _$tmp1 = {
    'shape': 'square',
    'variant': 'outlined',
    'content': 'square 是默认形状，更规整，适合偏工具型界面。'
};
var _$tmp2 = {
    'shape': 'corner',
    'variant': 'outlined',
    'content': 'corner 带一点对话尾巴的感觉，更像聊天气泡。'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Bubble, _$tmp0),
        _$cc(Bubble, _$tmp1),
        _$cc(Bubble, _$tmp2)
    ], 4, 'bubble-demo-shape');
};